import { imgUrls } from 'constants/imgUrls'
import React from 'react'
import { Carousel } from 'react-bootstrap'

const Home = () => {

    return (
        <Carousel>
            <Carousel.Item interval={3000}>
                {/* <ExampleCarouselImage text="First slide" /> */}
                <img src={imgUrls.slide1} />
                <Carousel.Caption>
                    <h3>First slide label</h3>
                    <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item interval={500}>
                <img src={imgUrls.slide1} />
                <Carousel.Caption>
                    <h3>Second slide label</h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <img src={imgUrls.slide1} />
                <Carousel.Caption>
                    <h3>Third slide label</h3>
                    <p>
                        Praesent commodo cursus magna, vel scelerisque nisl consectetur.
                    </p>
                </Carousel.Caption>
            </Carousel.Item>
        </Carousel>
    )
}

export default Home;